import Vue from 'vue'
import Vuex from 'vuex'
import event from "@/kim/utils/event";

Vue.use(Vuex)



const users=[
    {
        name: "狂沙百战",
        id: "1001",
        avatar: "http://res.itsub.cn/avatar/1.jpg",
        sign: "飘零雪域凋残月，万丈剑芒映虚空",
        state: 1,
    },
    {
        name: "北悸安凉",
        id: "1002",
        avatar: "http://res.itsub.cn/avatar/2.jpg",
        sign: "黑夜之下，光明即将来临",
        state: 0
    },
    {
        name: "安澜",
        id: "1003",
        type:'friend',
        avatar: "http://res.itsub.cn/avatar/3.jpg",
        sign: "仙之巅，傲世间，有我安澜便有天！",
        state: 1,
    },
    {
        name: "俞陀",
        id: "1004",
        type:'friend',
        avatar: "http://res.itsub.cn/avatar/4.jpg",
        sign: "安澜挺住，我来救你",
        state: 1,
    },
];
function findUserById(userid) {
    console.log('find:'+userid)
    for (var u of users) {
        if (u.id == userid) {
            return u;
        }
    }
    return null;
}

const store = new Vuex.Store({
    state: {
        config:{ //配置信息
            //获取群成员列表，默认传递id参数是群聊id
            members:{
                url:'http://res.itsub.cn/json/kim.members.json',
                type:'get',
                data:{}
            }
        },
        count: 0,
        skinImg:require('../skin/5.jpg'),
        chatboxShow:false,
        mine: {
            name: "KIM",
            id: "0",
            sign: "美好，如期而至",
            avatar: "http://res.itsub.cn/avatar/8.jpg",
            state:1, //在线状态，0离线或隐身，1在线
        },
        friends: [
           /* {
                groupname: "知名人物",
                open:true, //分组是否展开
                id: 1,//分组ID
                list: [
                    users[0],
                    users[1],
                ]
            },
            {
                groupname: "网络名人",
                open:true,
                id: 2,
                list: [
                    users[2],
                    users[3],
                ]
            }*/
        ],
        groups: [

        ],
        chats:[
            users[0],users[1],
        ],
        chating:[

        ],
        data:{ //本地存储的数据
            '10000':{
                chatlog:{
                    'friend1001':[
                        {
                            avatar: "http://res.itsub.cn/avatar/8.jpg",
                            content: "想飞上天和太阳肩并肩想飞上天和太阳肩并肩想飞上天和太阳肩并肩想飞上天和太阳肩并肩想飞上天和太阳肩并肩想飞上天和太阳肩并肩想飞上天和太阳肩并肩想飞上天和太阳肩并肩",
                            id: "10000",
                            mine: true,
                            timestamp: 1621300749049,
                            type: "friend",
                            name: "君莫笑",
                        },
                        {
                            avatar: "http://res.itsub.cn/avatar/1.jpg",
                            content: "狂沙百战穿金甲，不破楼兰终不还狂沙百战穿金甲，不破楼兰终不还狂沙百战穿金甲，不破楼兰终不还狂沙百战穿金甲，不破楼兰终不还狂沙百战穿金甲，不破楼兰终不还狂沙百战穿金甲，不破楼兰终不还",
                            id: "1001",
                            mine: false,
                            timestamp: 1621300748049,
                            type: "friend",
                            name: "狂沙百战",
                        },
                        {
                            system:true,
                            type:'friend',  //用于定位聊天
                            id: "1001",     //用于定位聊天
                            content: "这是一个系统消息",
                        },

                    ],
                    'group101':[
                        {
                            avatar: "",
                            content: "",
                            id: "10000",
                            mine: true,
                            timestamp: 1621300748049,
                            type: "group",
                            name: "好友名称",
                        }
                    ],
                },
            }
        }
    },
    mutations: {
        init(state,data){
            if (data.mine) state.mine=data.mine;
            if (data.friends)state.friends=data.friends;
            if (data.groups)state.groups=data.groups;
        },
        config(state, opts) {
            Object.assign(state.config, opts);
            console.log(state.config)
        },
        addChat (state,chat) {
            var user = null; //聊天目标
            for (var u of state.chats) {
                if (u.id == chat.id) {
                    user = u;
                }
            }
            if (!user) {
                state.chats.push(chat);
            }
        },
        updateUser(state, user) {
            console.log(user)
            let a = findUserById(user.id);
            console.log(a)
            //Object.assign(a, user);
            a.state=0;
        },
        addFriend(state, friend) {
            let r = state.friends.find(fg => fg.id == friend.gid);
            if (r) {
                //store.commit('removeFriend', friend.id);
                let f = r.list.find(fr => fr.id == friend.id);
                if (!f) {
                    r.list.push(friend);
                }else{
                    Object.assign(f, friend);
                }
            }
        },
        removeFriend(state, userid) {
            var r = store.findFriendIndex(userid);
            if (r) {
                state.friends[r.m].list.splice(r.n, 1);
            }
        },
        addMessage(state, data) {
            //data{ type,id, fromid,name,avatar,content,mine,timestamp }
            //type和id两个属性表示和谁的聊天，例如'friend100'，例如'group100'
            var target = data.type+''+data.id;
            var d = state.data;
            var a = d[state.mine.id];
            if (!a){
                a = d[state.mine.id] = {};
            }
            var b = a['chatlog'];
            if (!b) {
                b = a['chatlog'] = {}
            }
            var c = b[target];
            if (!c) {
                c = b[target] = [];
            }

            c.push(data);

            event.fire('msg-added', [data]);

        }
    },
    actions:{

    }
})

store.findFriendIndex=(id)=>{
    for (var m in store.state.friends) {
        var fg = store.state.friends[m];
        for (var n in fg.list) {
            let fr = fg.list[n];
            if (fr.id == id) {
                return {m:m,n:n}
            }
        }
    }
}
/* 根据id获取好友 */
store.getFriend=(fid)=>{
    return store.getFriendDict()[fid];
}
/* 获取好友字典（k:id，v:friend） */
store.getFriendDict=()=>{
    var map = {};
    for (var m in store.state.friends) {
        var fg = store.state.friends[m];
        for (var n in fg.list) {
            let fr = fg.list[n];
            fr.gid=fg.id;
            map[fr.id]=fr;
        }
    }
    return map;
}

export default store